import { Box, Typography } from '@mui/material'

export interface DonutSlice {
  label: string
  value: number
  color: string
}

const R = 58
const CX = 80
const SIZE = 160
const STROKE = 22
const CIRCUMFERENCE = 2 * Math.PI * R

export function DonutChart({ slices, centerLabel }: { slices: DonutSlice[], centerLabel?: string }) {
  const total = slices.reduce((s, d) => s + d.value, 0)
  let cumulative = 0

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap' }}>
      <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`} style={{ flexShrink: 0 }}>
        {/* Track */}
        <circle cx={CX} cy={CX} r={R} fill="none" stroke="#e2e8f0" strokeWidth={STROKE} />

        {total === 0 ? (
          <circle cx={CX} cy={CX} r={R} fill="none" stroke="#e2e8f0" strokeWidth={STROKE} />
        ) : (
          slices.map((slice, i) => {
            const pct = slice.value / total
            const dash = pct * CIRCUMFERENCE
            const gap  = CIRCUMFERENCE - dash
            const rotate = -90 + (cumulative / total) * 360
            cumulative += slice.value
            return (
              <circle
                key={i}
                cx={CX} cy={CX} r={R}
                fill="none"
                stroke={slice.color}
                strokeWidth={STROKE}
                strokeDasharray={`${dash} ${gap}`}
                transform={`rotate(${rotate} ${CX} ${CX})`}
              />
            )
          })
        )}

        {/* Centre */}
        <text x={CX} y={CX - 5} textAnchor="middle" fontSize="22" fontWeight="700" fill="#0f172a">
          {total}
        </text>
        <text x={CX} y={CX + 14} textAnchor="middle" fontSize="11" fill="#64748b">
          {centerLabel ?? 'hours'}
        </text>
      </svg>

      {/* Legend */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {slices.map((slice, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: slice.color, flexShrink: 0 }} />
            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>
              {slice.label}
            </Typography>
            <Typography variant="body2" fontWeight={600}>{slice.value}h</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
